import React, {useState} from 'react';
import { Link } from "react-router-dom";
import Card from '../components/Structure/Card.tsx';
import TextInput from '../components/Form/TextInput.tsx';
import Button from '../components/Form/Button.tsx';
import { useAuthlessApi } from '../features/auth/hooks/use-authless-api.ts';
import { ApiResponseType } from '../features/api/types.ts';

export default function PasswordForgot() {
    const [identifier, setIdentifier] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [inputValid, setInputValid] = useState(true);
    const { requestPasswordReset } = useAuthlessApi();

    const [responseMessage, setResponseMessage] = useState('');
    const [responseMessageClass, setResponseMessageClass] = useState('');

    const capturePWForgot = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        let errors = 0;
        if (identifier.length > 0) { 
            setInputValid(true);
            setResponseMessage('');
        } else { 
            setInputValid(false); 
            setResponseMessage('Bitte eine Kontaktnummer oder E-Mail-Adresse angeben');
            setResponseMessageClass('error');
            errors++;
        }

        if (errors > 0) {
            setIsLoading(false);
            return;
        }
        requestPasswordReset(identifier).then(data => {
            if (data.type === ApiResponseType.OK) {
                setResponseMessage('Sie erhalten eine E-Mail zum Zurücksetzen Ihres Passwortes. Bitte kontrollieren Sie auch Ihren Spam-Ordner.');
                setResponseMessageClass('success');
            } else {
                setResponseMessage(data.payload.error);
                setResponseMessageClass('error');
            }
            setIsLoading(false);
        }).catch(err => {
            setIsLoading(false);
        })
    }

    return (
        <Card
            p={'var(--spacing-2xl)'}
            gap={'var(--spacing-xl)'}
        >
            <h1 className="h3 align-center">Passwort vergessen</h1>
            <p className="m-0 align-center">Geben Sie die Kontaktnummer oder eine E-Mail-Adresse Ihres Kontos ein, und wir helfen Ihnen, ein neues Passwort festzulegen.</p>
            <form onSubmit={capturePWForgot} className={`pw-forgot-form${isLoading ? ' loading' : ''}`}>
                <div className="loader"></div>
                <TextInput
                    className={!inputValid ? 'invalid' : ''}
                    onChange={(e:any) => setIdentifier(e.target.value)}
                    value={identifier}
                    placeholder='Kontaktnummer oder E-Mail-Adresse'
                    name='name'
                    ariaLabel='Kontaktnummer oder E-Mail-Adresse'
                    required
                    autocomplete='username'
                    type='text'
                />
                { responseMessage && responseMessage.length > 0 && (
                    <div className={`message${responseMessageClass ? ' ' + responseMessageClass : ''}`} role="alert">
                        <span>
                            {responseMessage}
                        </span>
                    </div>
                )}
                <Button
                    fullWidth
                    buttonType='primary'
                    onClick={capturePWForgot}
                >Abschicken</Button>
                <p className="m-0 text-xs align-center" >zurück zur <Link className="text-xs" to={`/profile`}>Anmeldung</Link></p>
            </form>
        </Card>
    )
}